import { clsx } from 'clsx'
import type { ClassValue } from 'clsx'

import type { WheelItemsData, WheelItem } from '../wheelData'

type FeelingBadgeProps = {
  item: WheelItem
  wheelItemsData: WheelItemsData
  className?: ClassValue
}

export default function FeelingBadge({ item, wheelItemsData, className }: FeelingBadgeProps) {
  const firstLevelParent = getFirstLevelParent(item, wheelItemsData)
  return (
    <span
      className={clsx(
        'rounded-full bg-current',
        wheelItemsData[firstLevelParent].path.color.replace('fill', 'text'),
        className,
      )}
    />
  )
}

function getFirstLevelParent(item: WheelItem, wheelItemsData: WheelItemsData): WheelItem {
  const parent = wheelItemsData[item].parent
  const grandParent = parent && wheelItemsData[parent].parent
  return grandParent ?? parent ?? item
}
